import { EmptyStatePlaceholder } from '@dreryk/react-components';

import { draftPrescriptionsTranslationKeys } from '../../../../translations';

export const DraftPrescriptionsFormPlaceholder = (): JSX.Element => {
   return (
      <EmptyStatePlaceholder
         heading={draftPrescriptionsTranslationKeys.noMedicineSelected}
         subheading={draftPrescriptionsTranslationKeys.noMedicineSelectedAdditionalText}
         testId={'draftPrescriptionsForm'}
      />
   );
};
